import { errorTypes as types } from '../constants';
import produce from 'immer';

const initialState = [];

export default produce((draft, action) => {
    switch (action.type) {
        case types.UPDATE_ERROR:
            return action.payload;
        case types.CLEAR_ERROR:
            return [];
        default:
            return draft;
    }
}, initialState);
